import React from "react";
import { Link } from "react-router-dom";
import { Bone, Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function CouponCard({ coupon }) {
  const { t } = useTranslation();
  return (
    <Link
      to={`/cupones/${coupon.id}`}
      data-testid={`hueso-card-${coupon.id}`}
      className="group block relative bg-[#FEBA01] text-black overflow-hidden hover-lift rounded-xl outline-none focus:outline-none focus-visible:outline-none"
    >
      {coupon.sponsored && (
        <div className="absolute top-2 right-2 z-20 bg-black text-[#FEBA01] font-mono text-[9px] uppercase tracking-widest px-2 py-1 border border-[#FEBA01] flex items-center gap-1">
          <Sparkles size={10} /> {t("huesos.sponsoredTag")}
        </div>
      )}
      <div className="relative grid grid-cols-[1fr_auto] z-10">
        <div className="p-5">
          <div className="flex items-center gap-2 text-xs font-mono uppercase tracking-widest text-black/70">
            <Bone size={14} strokeWidth={2.2} /> {t("huesos.huesoKiltro")}
          </div>
          <h3 className="mt-2 font-display text-2xl leading-none uppercase tracking-tight">
            {coupon.title}
          </h3>
          <div className="mt-2 text-xs font-mono uppercase tracking-wider text-black/80">@ {coupon.venue_name}</div>
          <p className="mt-3 text-sm leading-snug line-clamp-2 font-medium">{coupon.description}</p>
          {coupon.valid_until && (
            <div className="mt-3 text-[10px] font-mono uppercase tracking-widest text-black/70">
              {t("huesos.validUntil")} {coupon.valid_until}
            </div>
          )}
        </div>
        <div className="bg-black text-[#FEBA01] flex flex-col items-center justify-center px-6 relative">
          <div className="font-display text-3xl uppercase tracking-tighter leading-none text-center">
            {coupon.discount}
          </div>
          <div className="mt-1 font-mono text-[9px] uppercase tracking-widest opacity-70">{t("huesos.reward")}</div>
        </div>
      </div>
    </Link>
  );
}
